import { Box, Typography, styled } from "@mui/material";

import { Topic } from "../../typings/Topic";

type CategoryBoxProps = {
    topic: Topic;
    selected: boolean;
    onClick: () => void;
};

const CategoryBox = ({ topic, selected, onClick }: CategoryBoxProps) => {
    return (
        <StyledBox selected={selected} onClick={onClick}>
            <Box width="100%" textAlign="center">
                <Typography
                    variant="h5"
                    color={selected ? "white" : "secondary.main"}
                >
                    {topic.name}
                </Typography>
            </Box>
        </StyledBox>
    );
};

export default CategoryBox;

type StyledBoxProps = {
    selected: boolean;
};

const StyledBox = styled(Box)<StyledBoxProps>(({ theme, selected }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 10,
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: selected
        ? theme.palette.secondary.main
        : theme.palette.primary.main,
    boxShadow: `3px 3px 0px ${theme.palette.secondary.main}`,
    height: 80,
    minWidth: 80,
    pointer: "cursor",
}));
